export enum Breakpoint {
    XSMALL = 'xsmall',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    XLARGE = 'xlarge',
    MAX = 'max'
}

// Must stay in descending order
const value = {
    [Breakpoint.MAX]: 1600,
    [Breakpoint.XLARGE]: 1280,
    [Breakpoint.LARGE]: 1024,
    [Breakpoint.MEDIUM]: 768,
    [Breakpoint.SMALL]: 576,
    [Breakpoint.XSMALL]: 0
};

const breakpoints: {
    name: typeof Breakpoint;
    value: {[key in Breakpoint]: number};
} = {
    name: Breakpoint,
    value
};

export default breakpoints;
